var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9053_22683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0454 5.0531L11.9048 4.19372C12.243 3.85541 12.6446 3.58703 13.0865 3.40393C13.5285 3.22083 14.0022 3.12659 14.4806 3.12659C14.9589 3.12659 15.4326 3.22083 15.8746 3.40393C16.3166 3.58703 16.7181 3.85541 17.0563 4.19372C17.3947 4.53195 17.663 4.9335 17.8461 5.37546C18.0292 5.81742 18.1235 6.29112 18.1235 6.76951C18.1235 7.24789 18.0292 7.72159 17.8461 8.16355C17.663 8.60551 17.3947 9.00707 17.0563 9.34529L15.1516 11.25L14.3438 12.0578C14.0052 12.3965 13.6031 12.665 13.1606 12.8482C12.7181 13.0313 12.2438 13.1254 11.7649 13.125C11.286 13.1246 10.8118 13.0298 10.3696 12.846C9.92735 12.6623 9.52569 12.3931 9.18758 12.0539C8.83762 11.704 8.56285 11.2864 8.38014 10.8265C8.19743 10.3666 8.11063 9.87428 8.12508 9.37966",
    stroke: "#005C8A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95461 14.9469L8.09524 15.8063C7.75662 16.1449 7.35455 16.4135 6.91202 16.5966C6.4695 16.7798 5.99522 16.8738 5.5163 16.8735C5.03739 16.8731 4.56324 16.7783 4.121 16.5945C3.67875 16.4107 3.27709 16.1415 2.93899 15.8024C2.25773 15.1187 1.87559 14.1927 1.87647 13.2276C1.87735 12.2624 2.26117 11.3371 2.94367 10.6547L5.65617 7.9422C5.9944 7.60388 6.39595 7.33551 6.83791 7.15241C7.27987 6.9693 7.75357 6.87506 8.23195 6.87506C8.71034 6.87506 9.18404 6.9693 9.626 7.15241C10.068 7.33551 10.4695 7.60388 10.8077 7.9422C11.1591 8.29201 11.4351 8.71012 11.6187 9.17074C11.8022 9.63135 11.8894 10.1247 11.8749 10.6203",
    stroke: "#005C8A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9053_22683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperLink);
export default __webpack_public_path__ + "static/media/HyperLink.908cf93b3d57076f4ceb66526edaf488.svg";
export { ForwardRef as ReactComponent };